(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
// self executing function here
(function() {
var countDownContainer = document.querySelector('.mocy-c--wrapper');
  if(countDownContainer){
var text = document.querySelector('.mocy-c--wrapper').dataset.countdownText;
var time = document.querySelector('.mocy-c--wrapper').dataset.countdownTime;
var textAfter = document.querySelector('.mocy-c--wrapper').dataset.countdownTextAfter;
  function calculateTime(exDate, text, textAfter){
    var countDownDate = new Date(exDate).getTime();
    var x = setInterval(function() {
      var now = new Date().getTime();
      var distance = countDownDate - now;
      var hours = Math.floor(distance / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      document.getElementById("mocy-c--content").innerHTML = text + " " + hours + "h "
        + minutes + "m " + seconds + "s ";
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("mocy-c--content").innerHTML = textAfter;
      }
    }, 1000);
  }
  calculateTime(time, text, textAfter);    
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  /**
   * Featured Collection Carousel - Inline JavaScript
   * Shopify automatically deduplicates this for multiple section instances
   * Loads asynchronously with defer attribute
   */

  /**
   * Initialize a collection carousel with Slick slider
   * @param {jQuery} $carousel - The carousel element to initialize
   */
  function initCollectionCarousel($carousel) {
    // Skip if already initialized
    if ($carousel.hasClass('slick-initialized')) {
      return;
    }

    var sectionId = $carousel.data('section-id');
    var slidesToShow = parseInt($carousel.data('slides-to-show')) || 4;
    var slidesTablet = parseInt($carousel.data('slides-tablet')) || 3;
    var slidesMobile = parseInt($carousel.data('slides-mobile')) || 2;

    // Check single scroll toggle
    // Note: Liquid booleans become strings, so we explicitly check for 'true'
    var singleScrollValue = $carousel.data('single-scroll');
    var singleScroll = singleScrollValue === true || String(singleScrollValue) === 'true';

    // Read centerMode settings for mobile
    var centerModeMobileValue = $carousel.data('center-mode-mobile');
    var centerModeMobile = centerModeMobileValue === true || String(centerModeMobileValue) === 'true';
    var centerPaddingMobile = parseInt($carousel.data('center-padding-mobile')) || 15;

    // Calculate scroll amounts based on toggle
    // If single scroll enabled: scroll 1 at a time
    // If disabled: scroll full page (slidesToShow amount)
    var slidesToScroll = singleScroll ? 1 : slidesToShow;
    var slidesScrollTablet = singleScroll ? 1 : slidesTablet;
    var slidesScrollMobile = singleScroll ? 1 : slidesMobile;

    var settings = {
      infinite: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToScroll,
      mobileFirst: true,
      swipe: true,
      arrows: true,
      dots: false,
      prevArrow: jQuery('#CollectionCarouselSection-' + sectionId + ' .slick-prev'),
      nextArrow: jQuery('#CollectionCarouselSection-' + sectionId + ' .slick-next'),
      adaptiveHeight: false,
      speed: 800,
      cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: Math.min(slidesToShow, 4),
            slidesToScroll: slidesToScroll,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: slidesTablet,
            slidesToScroll: slidesScrollTablet,
          },
        },
        {
          breakpoint: 0,
          settings: {
            slidesToShow: slidesMobile,
            slidesToScroll: slidesScrollMobile,
            centerMode: centerModeMobile,
            centerPadding: centerPaddingMobile + '%',
          },
        },
      ],
    };

    // Listen for Slick init event to hide loader and show carousel
    $carousel.on('init', function () {
      var $container = $carousel.closest('.collection-carousel-container');
      $container.addClass('carousel-initialized');
    });

    $carousel.slick(settings);

    // Ensure carousel-initialized class is added even if init already fired
    if ($carousel.hasClass('slick-initialized')) {
      var $container = $carousel.closest('.collection-carousel-container');
      $container.addClass('carousel-initialized');
    }

    // Position arrows centered on product images
    positionArrowsOnImages(sectionId);

    // Initialize pagination counter
    updatePaginationCounter(sectionId, $carousel);

    // Listen for slide changes
    $carousel.on('afterChange', function (event, slick, currentSlide) {
      updatePaginationCounter(sectionId, $carousel);
    });
  }

  /**
   * Update pagination counter display
   * @param {string} sectionId - The section ID
   * @param {jQuery} $carousel - The carousel element
   */
  function updatePaginationCounter(sectionId, $carousel) {
    var $section = jQuery('#CollectionCarouselSection-' + sectionId);
    var $currentSpan = $section.find('.carousel-pagination__current');
    var $totalSpan = $section.find('.carousel-pagination__total');

    if ($carousel.hasClass('slick-initialized')) {
      // Get current slide from Slick
      var currentSlide = $carousel.slick('slickCurrentSlide');
      var slidesToScroll = $carousel.slick('slickGetOption', 'slidesToScroll');
      var slideCount = $carousel.slick('getSlick').slideCount;

      // Calculate page number based on slidesToScroll
      // When scrolling 3 at a time: slides 0,1,2 = page 1, slides 3,4,5 = page 2, etc.
      var currentPage = Math.floor(currentSlide / slidesToScroll) + 1;

      // Calculate total pages
      var totalPages = Math.ceil(slideCount / slidesToScroll);

      // Update numbers if they exist
      if ($currentSpan.length) {
        $currentSpan.text(currentPage);
        $totalSpan.text(totalPages);
      }
    }
  }

  /**
   * Position navigation arrows centered on product images
   * @param {string} sectionId - The section ID
   */
  function positionArrowsOnImages(sectionId) {
    var $section = jQuery('#CollectionCarouselSection-' + sectionId);
    var $firstImage = $section.find('.collection-slide:first .grid-product__image-mask');

    if ($firstImage.length) {
      // Wait for image to load to get accurate height
      var checkImageHeight = function () {
        var imageHeight = $firstImage.outerHeight();
        if (imageHeight > 0) {
          var arrowTopPosition = imageHeight / 2;
          $section.find('.slick-nav').css({
            top: arrowTopPosition + 'px',
            transform: 'translateY(-50%)',
          });
        }
      };

      // Check immediately
      checkImageHeight();

      // Also check after images load (for lazy-loaded images)
      $firstImage.find('img').on('load', checkImageHeight);

      // Recalculate on window resize
      jQuery(window).on('resize', function () {
        checkImageHeight();
      });
    }
  }

  /**
   * Destroy a collection carousel Slick instance
   * @param {jQuery} $carousel - The carousel element to destroy
   */
  function destroyCollectionCarousel($carousel) {
    if ($carousel.hasClass('slick-initialized')) {
      $carousel.slick('unslick');
    }
  }

  // Initialize all carousels on page load
  jQuery(document).ready(function () {
    var collectionCarouselWrapper = jQuery('.collection-carousel-slider');

    if (collectionCarouselWrapper.length) {
      collectionCarouselWrapper.each(function () {
        initCollectionCarousel(jQuery(this));
      });
    }
  });

  // Shopify theme editor integration
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    // Section loaded or re-rendered in theme editor
    document.addEventListener('shopify:section:load', function (event) {
      var $section = jQuery(event.target);
      var $carousel = $section.find('.collection-carousel-slider');

      if ($carousel.length) {
        initCollectionCarousel($carousel);
        // Reposition arrows after a short delay to ensure images are rendered
        setTimeout(function () {
          var sectionId = $carousel.data('section-id');
          positionArrowsOnImages(sectionId);
        }, 100);
      }
    });

    // Section unloaded or being re-rendered in theme editor
    document.addEventListener('shopify:section:unload', function (event) {
      var $section = jQuery(event.target);
      var $carousel = $section.find('.collection-carousel-slider');

      if ($carousel.length) {
        destroyCollectionCarousel($carousel);
      }
    });

    // Optional: Pause carousel when section is selected for editing
    document.addEventListener('shopify:section:select', function (event) {
      var $section = jQuery(event.target);
      var $carousel = $section.find('.collection-carousel-slider');

      if ($carousel.length && $carousel.hasClass('slick-initialized')) {
        $carousel.slick('slickPause');
      }
    });

    // Optional: Resume carousel when section is deselected
    document.addEventListener('shopify:section:deselect', function (event) {
      var $section = jQuery(event.target);
      var $carousel = $section.find('.collection-carousel-slider');

      if ($carousel.length && $carousel.hasClass('slick-initialized')) {
        $carousel.slick('slickPlay');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
